import React from "react";
import Login from "../pages/Login/index"; // Use the folder structure with LoginForm component
import Dashboard from "../pages/Dashboard/index"; // Use the folder structure
import Settings from "../pages/Settings/index"; // Settings page for programme selection
import Results from "../pages/Results/index"; // Results page for submission success
import NUCDocuments from "../pages/Documents/NUCDocuments"; // NUC Documents page
import DAPDocuments from "../pages/Documents/DAPDocuments"; // DAP Documents page
import UploadDocuments from "../pages/Documents/UploadDocuments"; // Upload Documents page
import Signout from "../pages/Signout";
import NotFound from "../pages/NotFound/index";

// Placeholder pages - to be implemented
const ProgrammeSelection = () => (
  <div className="text-center py-12">
    <h1 className="text-2xl font-bold text-gray-900">Programme Selection</h1>
    <p className="mt-4 text-gray-600">This page is under development</p>
  </div>
);

const ScoreSubmission = () => (
  <div className="text-center py-12">
    <h1 className="text-2xl font-bold text-gray-900">Score Submission</h1>
    <p className="mt-4 text-gray-600">This page is under development</p>
  </div>
);

const Error404 = NotFound;

/**
 * Routes configuration
 * Define all application routes here
 */
export const routes = [
  // Public routes
  {
    path: "/login",
    element: <Login />,
    isProtected: false,
  },
  {
    path: "/",
    element: <Login />,
    isProtected: false,
  },
  // Protected routes
  {
    path: "/dashboard",
    element: <Dashboard />,
    isProtected: true,
  },
  {
    path: "/settings",
    element: <Settings />,
    isProtected: true,
  },
  {
    path: "/results",
    element: <Results />,
    isProtected: true,
  },
  {
    path: "/programme-selection",
    element: <ProgrammeSelection />,
    isProtected: true,
  },
  {
    path: "/score-submission",
    element: <ScoreSubmission />,
    isProtected: true,
  },
  {
    path: "/documents/nuc",
    element: <NUCDocuments />,
    isProtected: true,
  },
  {
    path: "/documents/dap",
    element: <DAPDocuments />,
    isProtected: true,
  },
  {
    path: "/documents/upload",
    element: <UploadDocuments />,
    isProtected: true,
  },
  {
    path: "/signout",
    element: <Signout />,
    isProtected: false,
  },
  // 404 page
  {
    path: "*",
    element: <Error404 />,
    isProtected: false,
  },
];

export { Login, Dashboard, Settings, Results, NUCDocuments, DAPDocuments, UploadDocuments, Signout, NotFound, Error404 };